/* eslint-disable no-param-reassign */
import React, { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
// import toast from 'react-hot-toast';
// import {Provider, CachePolicies} from 'use-http';

import { createAppQueryClient } from "../lib/queryClient";
import { AuthProvider } from "./auth-context";
import { AppReactQueryDevtools } from "./ReactQueryDevtoolsPanel";
// import {UserProvider} from './user-context';
interface Props {
  children: React.ReactNode;
}

const AppProviders: React.FC<Props> = ({ children }) => {
  const [queryClient] = useState(() => createAppQueryClient());

  return (
    // QueryClientProvider must wrap AuthProvider: logout clears the query cache, so
    // auth-context calls useQueryClient().
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <AppReactQueryDevtools />
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default AppProviders;
